// noinspection RegExpRedundantEscape
import { Box, Button, Checkbox, Grid, GridItem, H3, H4, InlineMessage, Modal, Panel,
    Search, Select, Table, Text } from "@bigcommerce/big-design";
import { useEffect, useState } from "react";
import { Box as MuiBox, List, ListItemButton, ListItemText } from "@mui/material";
import { getProductAttributes, refreshProductMapping } from "../api/products";
import { getCombinations, addCombination, updateCombination, removeCombination,
    searchLinkedProductsFromSku } from "../api/combinations";
import { showErrorMessage, showMessage } from "../utils/AlertMessage";
import { getProductByID, getInventoryBySKU, getProductDataBySKUs, getProductThumbnailImage,
    searchSecondaryProducts } from "../api/storefront/products";
import { setPrimaryProductPrice } from "../utils/Products";

const LinkVariableProductModal = (props) => {
    const EMPTY = '';

    const [attributes, setAttributes] = useState([]); // fetch from database
    const getAttributeFuncArray = [({attr_1}) => attr_1,
        ({attr_2}) => attr_2,
        ({attr_3}) => attr_3,
        ({attr_4}) => attr_4,
        ({attr_5}) => attr_5,
        ({attr_6}) => attr_6,
        ({attr_7}) => attr_7,
        ({attr_8}) => attr_8,
        ({attr_9}) => attr_9,
        ({attr_10}) => attr_10,
        ({attr_11}) => attr_11,
        ({attr_12}) => attr_12,
        ({attr_13}) => attr_13,
        ({attr_14}) => attr_14,
        ({attr_15}) => attr_15,
        ({attr_16}) => attr_16,
        ({attr_17}) => attr_17,
        ({attr_18}) => attr_18,
        ({attr_19}) => attr_19,
        ({attr_20}) => attr_20];

    const [productName, setProductName] = useState(EMPTY);
    const handleProductNameChange = (event) => setProductName(event.target.value);
    const [secondaryProductName, setSecondaryProductName] = useState(EMPTY);
    const handleSecondaryProductNameChange = (event) => {
        setCheckMatchName(false);
        /*if (secondaryProductName.trim().length === 0) {
            // Keep the previous state of Match Name Checkbox, before changing the search keywords
            setPrevStateCheckMatchName(checkMatchName);
            // Cannot search using both product name and search keywords
            setCheckMatchName(false);
        } else if (event.target.value.toString().trim().length === 0) {
            // Restore the previous state, after clearing the search keywords
            setCheckMatchName(prevStateCheckMatchName);
            // Load secondary products back
            props.setLoading(true);
            loadSecondaryProducts(selectedItems[0].name, selectedItems[0].categories, combinations, EMPTY, prevStateCheckMatchName, checkMatchCategory, itemsPerPageLinkProduct, 1).finally(() => props.setLoading(false));
        }*/
        setSecondaryProductName(event.target.value);
    }

    const [currentItems, setCurrentItems] = useState([]);
    const [selectedItems, setSelectedItems] = useState([]);
    const [currentPage, setCurrentPage] = useState(1);
    const [itemsPerPage, setItemsPerPage] = useState(5);
    const [itemsDisabled, setItemsDisabled] = useState(false);
    const [imageViewerOpened, setImageViewerOpened] = useState(false);
    const [imageViewerSrc, setImageViewerSrc] = useState(EMPTY);
    const [imageViewerPosition, setImageViewerPosition] = useState({x: 0, y: 0});
    const [modalSize, setModalSize] = useState({width: 0, height: 0});

    const [productAttributes, setProductAttributes] = useState([]);
    const [productAttributeValues, setProductAttributeValues] = useState([]);

    const [combinations, setCombinations] = useState([]);
    const [selectedCombinations, setSelectedCombinations] = useState([]);
    const [combinationColumns, setCombinationColumns] = useState([]);
    const [isOpenNewCombinationDialog, setIsOpenNewCombinationDialog] = useState(false);
    const [newCombinationAttributes, setNewCombinationAttributes] = useState([]);
    const [secondaryProducts, setSecondaryProducts] = useState([]);
    const [selectedSecondaryProducts, setSelectedSecondaryProducts] = useState([]);
    const [currentPageLinkProduct, setCurrentPageLinkProduct] = useState(1);
    const [itemsPerPageLinkProduct, setItemsPerPageLinkProduct] = useState(5);
    const [totalItemsLinkProduct, setTotalItemsLinkProduct] = useState(0);
    const [checkMatchName, setCheckMatchName] = useState(true);
    const [checkMatchCategory, setCheckMatchCategory] = useState(true);
    //const [prevStateCheckMatchName, setPrevStateCheckMatchName] = useState(true);

    useEffect(() => {
        const lazyLoadGridInfo = async () => {
            setItemsDisabled(true);
            const maxItems = currentPage * itemsPerPage;
            const lastItem = Math.min(maxItems, props.items.length);
            const firstItem = Math.max(0, maxItems - itemsPerPage);

            const slicedItems = props.items.slice(firstItem, lastItem);
            setCurrentItems(slicedItems); // Initially show items without image

            // LOAD PRODUCT DETAILS
            // Clone the array so we don't mutate state
            let updatedItems = await Promise.all(
                slicedItems.map(async (item) => {
                    try {
                        const result = await getProductByID(item.id);
                        let productDetails = result.success ? result.product : null;
                        let totalStock = 0;
                        if (item.combinations) {
                            const skuList = item.combinations.map(combination => combination.sku);
                            // Get total stock using list of SKUs from store (process in chunks to manage the load to storefront)
                            const chunkSize = 100;
                            let currentSliceStart = 0;
                            let currentSliceEnd = chunkSize;
                            while (currentSliceStart < skuList.length) {
                                if (currentSliceEnd > skuList.length)
                                    currentSliceEnd = skuList.length;
                                const currentSkuListSlice = skuList.slice(currentSliceStart, currentSliceEnd);

                                // Process data in chunks
                                totalStock += await getInventoryBySKU(currentSkuListSlice.join(','));

                                currentSliceStart = currentSliceEnd;
                                currentSliceEnd += chunkSize;
                            }
                        }
                        return {
                            ...item,
                            categories: productDetails ? productDetails.categories : [],
                            stock: totalStock
                        };
                    } catch (err) {
                        // Handle error (optional)
                        return {
                            ...item,
                            categories: [],
                            stock: 0
                        };
                    }
                })
            );
            setCurrentItems(updatedItems); // Update items with additional details

            // FETCH IMAGES
            // Clone the array so we don't mutate state
            updatedItems = await Promise.all(
                updatedItems.map(async (item) => {
                    try {
                        const images = await getProductThumbnailImage(item.id);
                        return {
                            ...item,
                            thumbnail_image_url: images.thumbnail_image_url || EMPTY,
                            tiny_image_url: images.tiny_image_url || EMPTY
                        };
                    } catch (err) {
                        // Handle error (optional)
                        return {
                            ...item,
                            thumbnail_image_url: EMPTY,
                            tiny_image_url: EMPTY
                        };
                    }
                })
            );
            setCurrentItems(updatedItems); // Update items with images
            setItemsDisabled(false);
        };

        lazyLoadGridInfo();
    }, [props.items, currentPage, itemsPerPage]);

    const loadProductAttributes = (attributes) => {
        let tempArr = [];
        attributes.forEach((element) => {
            tempArr.push(element.name);
        })
        setProductAttributes(tempArr);
    }
    const loadProductAttributeValues = (attributeIndex) => {
        let tempArr = [];
        attributes.forEach((element, index) => {
            if (index === attributeIndex) {
                tempArr = element.values;
            }
        })
        setProductAttributeValues(tempArr);
    }

    const handleItemSelection = async (items) => {
        if (items.length > 2)
            items.reverse();
        const currentSelection = items.pop();
        items = [];
        if (currentSelection)
            items.push(currentSelection);
        setSelectedItems(items);

        if (items.length > 0) {
            props.setLoading(true);
            try {
                // Load attributes of the selected product from database
                const attributes = await getProductAttributes(props.clientID, currentSelection.id);
                setAttributes(attributes);
                loadProductAttributes(attributes);

                // Load combinations of the selected product from database
                const combinations = await getCombinations(props.clientID, currentSelection.id);
                // Load name and stock from the store (process in chunks to manage the load to storefront)
                const chunkSize = 100;
                let currentSliceStart = 0;
                let currentSliceEnd = chunkSize;
                while (currentSliceStart < combinations.length) {
                    if (currentSliceEnd > combinations.length)
                        currentSliceEnd = combinations.length;
                    const currentCombinationsSlice = combinations.slice(currentSliceStart, currentSliceEnd);

                    // Process data in chunks
                    const secProductData = await getProductDataBySKUs(currentCombinationsSlice.map(variation => variation.sku).join(','));
                    combinations.forEach(combination => {
                        const secProduct = secProductData.find(secProduct => secProduct.sku === combination.sku);
                        if (secProduct) {
                            combination.name = secProduct.name;
                            combination.stock = secProduct.stock;
                        }
                    });

                    currentSliceStart = currentSliceEnd;
                    currentSliceEnd += chunkSize;
                }
                setCombinations(combinations);

                // Prepare dynamic columns placing the fetched attributes
                const columns = [];
                attributes.forEach((element, index) => {
                    columns.push({
                        header: element.name,
                        hash: 'attr_' + (index + 1),
                        render: getAttributeFuncArray[index]
                    });
                })
                setCombinationColumns(columns);

                // Load secondary products from the store
                loadSecondaryProducts(currentSelection.name, currentSelection.categories, combinations, EMPTY, true, true, 5, 1).then();
            } finally {
                props.setLoading(false);
            }
        } else {
            setProductAttributes([]);
            setCombinations([]);
            setCombinationColumns([]);
        }

        setSelectedAttributeIndex(-1);
        setProductAttributeValues([]);
        setSelectedAttributeValueIndex(-1);
        setSelectedCombinations([]);
        // Reset Link Product options
        setSecondaryProductName(EMPTY);
        setSelectedSecondaryProducts([]);
        setCheckMatchName(true);
        setCheckMatchCategory(true);
        setItemsPerPageLinkProduct(5);
        setCurrentPageLinkProduct(1);
    };
    const remCombination = async () => {
        if (selectedCombinations.length > 0) {
            const index = combinations.indexOf(selectedCombinations[0]);
            if (index >= 0) {
                if (selectedCombinations[0].sku === "") {
                    // When no product is linked
                    // Unlink the linked secondary product of the selected combination
                    const tempArr = JSON.parse(JSON.stringify(combinations));
                    tempArr.splice(index, 1);
                    setCombinations(tempArr);
                    setSelectedCombinations([]);
                } else {
                    // Remove the combination from database
                    const combination = {...selectedCombinations[0]};
                    delete combination.name;
                    delete combination.stock;
                    const result = await removeCombination(props.clientID, selectedItems[0].id, combination);
                    if (result.error)
                        showErrorMessage('Error', result.message);
                    else {
                        showMessage('Removed', result.message);
                        // Unlink the linked secondary product of the selected combination
                        const tempArr = JSON.parse(JSON.stringify(combinations));
                        tempArr.splice(index, 1);
                        setCombinations(tempArr);
                        setSelectedCombinations([]);
                        // Task 1: Loop through SKUs and update primary product data
                        const updatedSkuList = tempArr.map(combination => combination.sku);
                        await setPrimaryProductPrice(selectedItems[0].id, updatedSkuList);
                        // Task 2: Update public product mapping
                        await refreshProductMapping(props.clientID, selectedItems[0].id);
                    }
                }
            }
        }
    }

    const [selectedAttributeIndex, setSelectedAttributeIndex] = useState(-1);
    const [selectedAttributeValueIndex, setSelectedAttributeValueIndex] = useState(-1);
    const handleAttributeClick = (event, index) => {
        setSelectedAttributeIndex(index);

        loadProductAttributeValues(index);
        setSelectedAttributeValueIndex(-1);
    };
    const handleAttributeValueClick = (event, index) => {
        setSelectedAttributeValueIndex(index);
    };

    const openNewCombinationDialog = () => {
        //Reset new combination in dialog
        const tempArr = [];
        attributes.forEach((element, index) => {
            tempArr.push({attributeIndex: index, selectedValue: null});
        })
        setNewCombinationAttributes(tempArr);

        setIsOpenNewCombinationDialog(true);
    }
    const getAttributeValues = (attributeIndex) => {
        //Load elements from attributes and populate values to setup combinations
        const attributeValues = [];
        attributes.forEach((element, index) => {
            if (index === attributeIndex) {
                element.values.forEach((valueElement, valueIndex) => {
                    attributeValues.push({value: valueIndex, content: valueElement});
                });
            }
        });
        return attributeValues;
    }
    const handleCombinationSelection = (items) => {
        if (items.length > 2)
            items.reverse();
        const currentSelection = items.pop();
        items = [];
        if (currentSelection)
            items.push(currentSelection);
        setSelectedCombinations(items);

        // Find the linked secondary product and select it
        if (currentSelection && currentSelection.sku !== "") {
            let found = false;
            secondaryProducts.forEach((element) => {
                if (element.sku === currentSelection.sku) {
                    found = true;
                    handleSecondaryProductSelection([element]);
                }
            });
            if (!found)
                setSelectedSecondaryProducts([]);
        } else {
            setSelectedSecondaryProducts([]);
        }
    }
    const handleNewCombinationAttributeSelection = (attributeIndex, selectedValue) => {
        newCombinationAttributes.forEach((element, index) => {
            if (index === attributeIndex) {
                newCombinationAttributes.at(index).selectedValue = selectedValue;
            }
        });
    }
    const addNewCombination = () => {
        let isValid = true;
        const newRecordAttrValues = [];
        let combinationAttributes = '{ ';
        for (const newAttribute of newCombinationAttributes) {
            if (isValid && (!newAttribute.selectedValue || newAttribute.selectedValue.toString() === "")) {
                showErrorMessage('Required Field', productAttributes.at(newAttribute.attributeIndex) + ' is Required.');
                isValid = false;
                continue;
            }
            newRecordAttrValues.push(newAttribute.selectedValue);
            combinationAttributes += '"attr_' + (newAttribute.attributeIndex + 1) + '": "' + newAttribute.selectedValue + '", ';
        }
        combinationAttributes += '"sku": "", "name": "", "stock": 0 }';

        if (isValid) {
            // Check for any existing combination for duplicates
            for (const combination of combinations) {
                const values = [];
                Object.keys(combination).forEach((key) => {
                    if (key.startsWith('attr_'))
                        values.push(combination[key]);
                });
                if (values.toString() === newRecordAttrValues.toString()) {
                    showErrorMessage('Duplicate Combination', 'An existing combination found with the values you provided for each attribute.');
                    isValid = false;
                }
            }

            if (isValid) {
                const combinationAttributesJSON = JSON.parse(combinationAttributes);
                const tempArr = [...combinations];
                tempArr.push(combinationAttributesJSON);
                handleCombinationSelection([combinationAttributesJSON]); // Select the newly added combination
                setCombinations(tempArr);
            }
        }
        setIsOpenNewCombinationDialog(false);
    }

    const loadSecondaryProducts = async (productName, categories, combinations, searchName, checkMatchName, checkMatchCategory, itemsPerPage, currentPage) => {
        let searchKeyword;
        let secProducts;

        if (checkMatchName) {
            // eslint-disable-next-line no-useless-escape
            //const firstSpecialChar = /[-._!"`'#%&,:;<>=@{}~\$\(\)\*\+\/\\\?\[\]\^\|]+/.exec(productName);
            const firstSpecialChar = /[-._!#%&,:;<>=@{}~\$\(\)\*\+\/\\\?\[\]\^\|]+/.exec(productName); // Removed quotations
            if (firstSpecialChar)
                // Take the Product Name until the first special character as the Search Keyword
                searchKeyword = productName.toString().substring(0, firstSpecialChar.index).trim();
            else
                searchKeyword = productName.trim();

            // Do a strategic search to make sure there are search results for this keyword
            let tempSearchKeyword = searchKeyword;
            // Keep searching until we get a result by reducing words one by one from the end of the keyword
            while (tempSearchKeyword.length > 0) {
                secProducts = await searchSecondaryProducts(tempSearchKeyword, checkMatchCategory ? categories : [], itemsPerPage, currentPage);
                if (secProducts.data.length > 0) {
                    if (tempSearchKeyword !== searchKeyword)
                        console.info('searchKeyword(strategic):', tempSearchKeyword);
                    searchKeyword = tempSearchKeyword;
                    break;
                }
                const words = tempSearchKeyword.split(' ');
                if (words.length <= 1)
                    break;
                tempSearchKeyword = tempSearchKeyword.replace(words[words.length - 1].trim(), EMPTY).trim();
            }
            if (!secProducts || secProducts.data.length === 0)
                console.info('No search results found even after strategic search.');
        } else
            searchKeyword = searchName.toString().trim(); // Search with the search box value
        console.info('searchKeyword:', searchKeyword);

        // Set search keyword to the search box value
        setSecondaryProductName(searchKeyword);

        if (!secProducts)
            secProducts = await searchSecondaryProducts(searchKeyword, checkMatchCategory ? categories : [], itemsPerPage, currentPage);
        // Identify already linked products to mark as disabled
        if (secProducts.data.length > 0) {
            const productSku = [];
            secProducts.data.forEach((secProduct) => productSku.push(secProduct.sku));
            let linkedProducts = await searchLinkedProductsFromSku(props.clientID, productSku);
            // Exclude SKUs used in current primary product
            combinations.filter((combination) => linkedProducts.indexOf(combination.sku) >= 0).forEach((combination) => {
                linkedProducts = linkedProducts.filter(sku => sku !== combination.sku);
            });
            // Mark as disabled
            if (linkedProducts.length > 0)
                secProducts.data.forEach((secProduct) => {
                    secProduct.disabled = linkedProducts.indexOf(secProduct.sku) >= 0;
                });
        }
        // Set product data
        setSecondaryProducts(secProducts.data);
        setTotalItemsLinkProduct(secProducts.totalItems);
        // Select the previously chosen or the already linked secondary product
        if (selectedCombinations[0])
            if (selectedCombinations[0].sku === "" || (selectedSecondaryProducts[0] && selectedSecondaryProducts[0].sku !== selectedCombinations[0].sku)) {
                if (selectedSecondaryProducts[0]) {
                    secProducts.data.forEach((element) => {
                        if (element.sku === selectedSecondaryProducts[0].sku) {
                            setSelectedSecondaryProducts([element]);
                        }
                    });
                }
            } else {
                secProducts.data.forEach((element) => {
                    if (element.sku === selectedCombinations[0].sku) {
                        setSelectedSecondaryProducts([element]);
                    }
                });
            }
        else
            setSelectedSecondaryProducts([]);

        return secProducts.data;
    }
    const handleSecondaryProductSelection = (items) => {
        // Check allowed
        if (items.length > 0 && items[items.length - 1].disabled) {
            showErrorMessage('Linked to Another Primary', 'The item you requested to link has been linked to another primary product.');
            return;
        }
        /*if (secondaryProducts.filter(secProduct => secProduct.sku === items[items.length - 1].sku)[0].disabled) {
            showErrorMessage('Linked to Another Primary', 'The item you requested to link has been linked to another primary product.');
            return;
        }*/
        // Proceed
        if (items.length > 2)
            items.reverse();
        const currentSelection = items.pop();
        items = [];
        if (currentSelection)
            items.push(currentSelection);
        setSelectedSecondaryProducts(items);
    }
    const handleMatchNameChange = () => {
        setCheckMatchName(!checkMatchName);
        //setPrevStateCheckMatchName(!checkMatchName);
        setSecondaryProductName(EMPTY);
        setCurrentPageLinkProduct(1);
        // Re-load secondary products based on name
        props.setLoading(true);
        loadSecondaryProducts(selectedItems[0].name, selectedItems[0].categories, combinations, EMPTY, !checkMatchName, checkMatchCategory, itemsPerPageLinkProduct, 1).finally(() => props.setLoading(false));
    }
    const handleMatchCategoryChange = () => {
        setCheckMatchCategory(!checkMatchCategory);
        setCurrentPageLinkProduct(1);
        // Re-load secondary products based on category
        props.setLoading(true);
        loadSecondaryProducts(selectedItems[0].name, selectedItems[0].categories, combinations, secondaryProductName, checkMatchName, !checkMatchCategory, itemsPerPageLinkProduct, 1).finally(() => props.setLoading(false));
    }
    const handleItemsPerPageLinkProductChange = (newRange) => {
        setItemsPerPageLinkProduct(newRange);
        setCurrentPageLinkProduct(1);
        // Load secondary products
        props.setLoading(true);
        loadSecondaryProducts(selectedItems[0].name, selectedItems[0].categories, combinations, secondaryProductName, checkMatchName, checkMatchCategory, newRange, 1).finally(() => props.setLoading(false));
    }
    const handleCurrentPageLinkProductChange = (newPage) => {
        setCurrentPageLinkProduct(newPage);
        // Load secondary products
        if (selectedItems.length > 0) {
            props.setLoading(true);
            loadSecondaryProducts(selectedItems[0].name, selectedItems[0].categories, combinations, secondaryProductName, checkMatchName, checkMatchCategory, itemsPerPageLinkProduct, newPage).finally(() => props.setLoading(false));
        } else {
            // Set product data
            setSecondaryProducts([]);
            setTotalItemsLinkProduct(0);
            setSelectedSecondaryProducts([]);
        }
    }
    const linkProduct = async () => {
        if (selectedSecondaryProducts.length > 0 && selectedCombinations.length > 0) {
            // Validations
            // Check whether already linked in existing combinations of the primary product
            if (combinations.filter(combination => combination.sku === selectedSecondaryProducts[0].sku).length > 0) {
                showErrorMessage('Already Linked', 'The product you are trying to link is already linked to another combination.')
                return;
            }

            let result;
            if (!selectedCombinations[0].sku || selectedCombinations[0].sku === "") {
                // Add the new combination in database
                const newCombination = {...selectedCombinations[0]};
                newCombination.sku = selectedSecondaryProducts[0].sku;
                delete newCombination.name;
                delete newCombination.stock;

                result = await addCombination(props.clientID, selectedItems[0].id, newCombination);
                if (result.error)
                    showErrorMessage('Error', result.message);
                else
                    showMessage('Linked', result.message);
            } else {
                // Update the combination in database
                const newCombination = {...selectedCombinations[0]};
                newCombination.sku = selectedSecondaryProducts[0].sku;
                delete newCombination.name;
                delete newCombination.stock;

                result = await updateCombination(props.clientID, selectedItems[0].id, newCombination, selectedCombinations[0].sku);
                if (result.error)
                    showErrorMessage('Error', result.message);
                else
                    showMessage('Linked', result.message);
            }

            if (result && !result.error) {
                // Link the selected secondary product to the selected combination
                const selectedCombinationIndex = combinations.indexOf(selectedCombinations[0]);
                combinations[selectedCombinationIndex].sku = selectedSecondaryProducts[0].sku;
                combinations[selectedCombinationIndex].name = selectedSecondaryProducts[0].name;
                combinations[selectedCombinationIndex].stock = selectedSecondaryProducts[0].stock;
                setSelectedCombinations([combinations[selectedCombinationIndex]]);
            }

            // Task 1: Loop through SKUs and update primary product data
            const updatedSkuList = combinations.map(combination => combination.sku);
            await setPrimaryProductPrice(selectedItems[0].id, updatedSkuList);
            // Task 2: Update public product mapping
            await refreshProductMapping(props.clientID, selectedItems[0].id);
        }
    }

    const onSubmitItemSearch = () => {
        setSelectedItems([]);
        props.setItems((prevItems) => {
            if (productName) {
                return prevItems.filter((item) => item.name.toLowerCase().includes(productName.toLowerCase()));
            }
            return props.primaryProductData;
        });
    }
    const onSubmitSecondaryProductSearch = async () => {
        setCurrentPageLinkProduct(1);
        if (!selectedCombinations || selectedCombinations.length === 0)
            return [];

        // Load secondary products
        props.setLoading(true);
        return await loadSecondaryProducts(selectedItems[0].name, selectedItems[0].categories, combinations, secondaryProductName, checkMatchName, checkMatchCategory, itemsPerPageLinkProduct, 1).finally(() => props.setLoading(false));
    }

    const openImageViewer = (event, id) => {
        props.items.forEach((item, index) => {
            if (item.id === id) {
                setImageViewerSrc(item.thumbnail_image_url);
                setImageViewerPosition({
                    x: (modalSize.width + 20),
                    y: 50 + (index * 72) + event.clientY - event.target.y
                });
                setImageViewerOpened(true);
            }
        });
    }

    const closeModal = () => {
        setProductName(EMPTY);
        props.setItems(props.primaryProductData);
        setSelectedItems([]);
        setProductAttributes([]);
        setSelectedAttributeIndex(-1);
        setProductAttributeValues([]);
        setSelectedAttributeValueIndex(-1);
        setCombinations([]);
        setSelectedCombinations([]);
        props.setIsOpen(false);
    }

    return (
        <>
            <Modal
                actions={[
                    {
                        text: 'Close',
                        variant: 'secondary',
                        onClick: closeModal,
                    }
                ]}
                closeOnClickOutside={false}
                closeOnEscKey={true}
                header="Link Variable Products"
                isOpen={props.isOpen}
                onClose={closeModal}
            >
                <div ref={el => {
                    if (!el || modalSize.width !== 0) return;
                    setModalSize({width: el.getBoundingClientRect().width, height: el.getBoundingClientRect().height});
                }}
                     onMouseEnter={() => setImageViewerOpened(false)}
                     style={{minHeight: '60vh'}}>
                    <Grid gridColumns="1fr 5fr" paddingTop="20px" style={{alignItems: 'baseline'}}>
                        <Text bold={true}>Product Name</Text>
                        <Search onChange={handleProductNameChange} onSubmit={onSubmitItemSearch}
                                value={productName}
                                placeholder="Type a Primary Product Name to Search"/>
                    </Grid>
                    <div className="wide-table" style={{ pointerEvents: itemsDisabled ? 'none' : 'auto', opacity: itemsDisabled ? 0.5 : 1 }}>
                        <Table
                            columns={[
                                {header: EMPTY, hash: 'id', render: () => {}, width: '0.01rem'},
                                {header: 'Name', hash: 'name', render: ({name}) => name},
                                {header: 'Variations', hash: 'variations', render: ({variations}) => variations, align: 'center'},
                                {header: 'Total Stock', hash: 'stock', render: ({stock}) => stock, align: 'center'},
                                {header: EMPTY, hash: 'tiny_image_url', render: ({tiny_image_url, id}) => {
                                        return (<MuiBox component='img' src={tiny_image_url}
                                                        onMouseEnter={(event) => openImageViewer(event, id)}
                                                        onMouseLeave={() => setImageViewerOpened(false)}/>)
                                    }, width: '5rem', align: 'center'},
                            ]}
                            items={currentItems}
                            selectable={{
                                selectedItems: selectedItems,
                                onSelectionChange: handleItemSelection,
                            }}
                            onMouseEnter={() => setImageViewerOpened(false)}
                            keyField="id"
                            pagination={{
                                currentPage: currentPage,
                                totalItems: props.items.length,
                                onPageChange: setCurrentPage,
                                itemsPerPageOptions: [5, 10],
                                itemsPerPage: itemsPerPage,
                                onItemsPerPageChange: (newRange) => {
                                    setCurrentPage(1);
                                    setItemsPerPage(newRange);
                                }
                            }}
                        />
                    </div>
                    <div className={!imageViewerOpened ? 'force-hide' : ''}
                         style={{
                             position: "absolute",
                             left: imageViewerPosition.x,
                             top: imageViewerPosition.y,
                             zIndex: 1100
                         }}>
                        <MuiBox component='img' src={imageViewerSrc} sx={{boxShadow: 3}}/>
                    </div>
                    <div className={(props.items.length > 0 || selectedItems.length > 0) ? 'force-hide' : ''}>
                        <InlineMessage
                            marginVertical="small"
                            messages={[{text: 'Please select your preferred primary product from the above list.'}]}
                            type="info"
                        />
                    </div>
                    <div className={selectedItems.length === 0 ? 'force-hide' : ''}>
                        <Panel marginTop="large">
                            <div className={selectedAttributeIndex >= 0 ? 'force-hide' : ''}>
                                <InlineMessage
                                    marginVertical="small"
                                    messages={[{text: 'Select an attribute to view its values.'}]}
                                    type="info"
                                />
                            </div>
                            <Grid gridColumns="1fr 1fr" paddingTop="small"
                                  onMouseEnter={() => setImageViewerOpened(false)}>
                                <GridItem>
                                    <center>
                                        <H4>View Attributes</H4>
                                        <List component="nav" aria-label="secondary mailbox folders"
                                              style={{overflowY: "scroll", maxHeight: "30vh"}}>
                                            {productAttributes.map((label, index) => (
                                                <ListItemButton
                                                    selected={selectedAttributeIndex === index}
                                                    onClick={(event) => handleAttributeClick(event, index)}
                                                >
                                                    <ListItemText primary={label}/>
                                                </ListItemButton>
                                            ))}
                                        </List>
                                    </center>
                                </GridItem>
                                <GridItem>
                                    <center>
                                        <H4>View Values</H4>
                                        <List component="nav" aria-label="secondary mailbox folders"
                                              style={{overflowY: "scroll", maxHeight: "30vh"}}>
                                            {productAttributeValues.map((label, index) => (
                                                <ListItemButton
                                                    selected={selectedAttributeValueIndex === index}
                                                    onClick={(event) => handleAttributeValueClick(event, index)}
                                                >
                                                    <ListItemText primary={label}/>
                                                </ListItemButton>
                                            ))}
                                        </List>
                                    </center>
                                </GridItem>
                            </Grid>
                        </Panel>
                        <Grid paddingTop="30px">
                            <GridItem>
                            <center>
                                    <H3>Combinations</H3>
                                    <div style={{overflow: "scroll", maxHeight: "50vh"}} className="wide-table">
                                        <Table
                                            columns={[
                                                ...combinationColumns,
                                                {header: 'SKU', hash: 'sku', render: ({sku}) => sku},
                                                {
                                                    header: 'Product Name',
                                                    hash: 'name',
                                                    render: ({name}) => (<div style={{minWidth: '20rem'}}>{name}</div>)
                                                },
                                                {
                                                    header: 'Stock',
                                                    hash: 'stock',
                                                    render: ({stock}) => stock,
                                                    align: "right"
                                                },
                                            ]}
                                            items={combinations}
                                            selectable={{
                                                selectedItems: selectedCombinations,
                                                onSelectionChange: handleCombinationSelection,
                                            }}
                                            keyField="sku"
                                        />
                                    </div>
                                </center>
                                <div align="right">
                                    <Box padding="small">
                                        <Button margin="xxSmall" actionType="normal" onClick={openNewCombinationDialog}>
                                            + Add New
                                        </Button>
                                        <Button margin="xxSmall" actionType="destructive" onClick={remCombination}
                                                disabled={selectedCombinations.length === 0}>- Remove</Button>
                                    </Box>
                                </div>
                            </GridItem>
                        </Grid>
                        <Grid paddingTop="30px">
                            <GridItem>
                                <center style={{paddingBottom: '10px'}}>
                                    <H3>Link Product</H3>
                                </center>
                                <div className={selectedCombinations.length > 0 ? 'force-hide' : ''}>
                                    <InlineMessage
                                        marginVertical="small"
                                        messages={[{text: 'Select a combination from the above list to view all secondary products to link.'}]}
                                        type="info"
                                    />
                                </div>
                                <div style={{display: "flex", margin: '0px 10px 10px 10px'}}>
                                    <div style={{margin: '5px'}}>
                                        <Checkbox
                                            checked={checkMatchName}
                                            label='Includes Name of Primary'
                                            onChange={handleMatchNameChange}
                                            disabled={selectedCombinations.length === 0}
                                        />
                                    </div>
                                    <div style={{margin: '5px'}}>
                                        <Checkbox
                                            checked={checkMatchCategory}
                                            label='Match Category of Primary'
                                            onChange={handleMatchCategoryChange}
                                            disabled={selectedCombinations.length === 0 || selectedItems[0].categories.length === 0}
                                        />
                                    </div>
                                </div>
                                <div className="equal-rows-table">
                                    <Search onChange={handleSecondaryProductNameChange}
                                            onSubmit={onSubmitSecondaryProductSearch} value={secondaryProductName}
                                            placeholder="Search (e.g. Name, SKU, Description, etc.)"
                                            disabled={selectedCombinations.length === 0}/>
                                    <div className={selectedCombinations.length === 0 || (selectedCombinations.length > 0 && secondaryProducts.length > 0) ? 'force-hide' : ''}>
                                        <InlineMessage
                                            marginVertical="small"
                                            messages={[{text: 'A product qualifies to become a secondary product by having an SKU and being Visible. In case you cannot find the product, make sure it has an SKU and it is Visible in your store.'}]}
                                            type="info"
                                        />
                                    </div>
                                    <Table
                                        columns={[
                                            {
                                                header: 'SKU',
                                                hash: 'sku',
                                                render: ({sku, disabled}) => <Text
                                                    color={disabled ? "danger50" : "currentColor"}>{sku}</Text>
                                            },
                                            {
                                                header: 'Name',
                                                hash: 'name',
                                                render: ({name, disabled}) => <Text
                                                    color={disabled ? "danger50" : "currentColor"}>{name}</Text>
                                            },
                                            {
                                                header: 'Stock',
                                                hash: 'stock',
                                                render: ({stock, disabled}) => <Text
                                                    color={disabled ? "danger50" : "currentColor"}>{stock}</Text>
                                            },
                                        ]}
                                        items={selectedCombinations[0] ? secondaryProducts : []}
                                        selectable={{
                                            selectedItems: selectedSecondaryProducts,
                                            onSelectionChange: handleSecondaryProductSelection
                                        }}
                                        keyField="sku"
                                        pagination={{
                                            currentPage: currentPageLinkProduct,
                                            totalItems: selectedCombinations[0] ? totalItemsLinkProduct : 0,
                                            onPageChange: handleCurrentPageLinkProductChange,
                                            itemsPerPageOptions: [5, 10],
                                            itemsPerPage: itemsPerPageLinkProduct,
                                            onItemsPerPageChange: handleItemsPerPageLinkProductChange
                                        }}
                                    />
                                </div>
                                <div className={selectedCombinations.length === 0 || (selectedCombinations.length > 0 && secondaryProducts.length === 0) ? 'force-hide' : ''}>
                                    <InlineMessage
                                        marginVertical="xxSmall"
                                        messages={[{text: 'Recently modified products displayed first.'}]}
                                        type="success"
                                    />
                                </div>
                                <div align="right">
                                    <Box paddingHorizontal="small">
                                        <Button margin="xxSmall" actionType="normal" onClick={linkProduct}
                                                disabled={selectedSecondaryProducts.length === 0 || (selectedCombinations.length > 0 && selectedCombinations[0].sku === selectedSecondaryProducts[0].sku) || secondaryProducts.filter(product => product.sku === selectedSecondaryProducts[0].sku).length === 0}>
                                            Link Product
                                        </Button>
                                    </Box>
                                </div>
                            </GridItem>
                        </Grid>
                    </div>
                </div>
            </Modal>
            <Modal
                variant="dialog"
                actions={[
                    {
                        text: 'Cancel',
                        variant: 'subtle',
                        onClick: () => setIsOpenNewCombinationDialog(false),
                    },
                    {text: '+ Add', onClick: () => addNewCombination(), /*disabled: !newCombination*/},
                ]}
                closeOnClickOutside={false}
                closeOnEscKey={true}
                header="Add New Combination"
                isOpen={isOpenNewCombinationDialog}
                onClose={() => setIsOpenNewCombinationDialog(false)}
            >
                <Grid gridColumns="repeat(2, 1fr)">
                    {productAttributes.map((label, index) => (
                        <Select
                            error=""
                            label={label}
                            onOptionChange={(value, option) => handleNewCombinationAttributeSelection(index, option.content)}
                            options={getAttributeValues(index)}
                            placeholder={"Choose " + label?.toLowerCase()}
                            placement="bottom-start"
                            required
                        />
                    ))}
                </Grid>
            </Modal>
        </>
    );
}

export default LinkVariableProductModal;